function getGuid() {
  let d = new Date().getTime()
  let d2 = (performance && performance.now && performance.now() * 1000) || 0
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    let r = Math.random() * 16
    if (d > 0) {
      r = (d + r) % 16 | 0
      d = Math.floor(d / 16)
    } else {
      r = (d2 + r) % 16 | 0
      d2 = Math.floor(d2 / 16)
    }
    return (c === "x" ? r : (r & 0x7) | 0x8).toString(16)
  })
}

function formatCurrency(money) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  })

  return formatter.format(money)
}

const quantitySelect = document.querySelectorAll("[data-ec-quantity-select]")
const frequencySelect = document.querySelectorAll("[data-ec-frequency-select]")

// SETTINGS
const bundle = {
  selectedProduct: {},
  product: null,
  settings: {
    limitPerItem: 999,
    bundleMin: 2,
    bundleMax: 5,
    itemSelector: "[data-ec-bundle-item]",
    itemIncreaseButtonSelector: ".add-to-cart",
    itemInCartClass: "in-cart",
    itemsInCartSelector: ".bundle-card.in-cart",
    bundleItemKey: "ec-bundle-cart",
  },
  defaults: {
    getModal: function () {
      return document.querySelector("#product-info-modal")
    },
    items() {
      return document.querySelectorAll(bundle.settings.itemSelector)
    },
    inCartItems() {
      return document.querySelectorAll(bundle.settings.itemsInCartSelector)
    },
    getProductData() {
      const parsed = JSON.parse(document.querySelector("#essential-club-product-data").textContent)
      return parsed.products
    },
  },
  utils: {
    clearCart() {
      const inCartItems = bundle.defaults.inCartItems()

      inCartItems.forEach((item) => {
        item.setAttribute("data-qty", 0)
        item.classList.remove(bundle.settings.itemInCartClass)
        item.querySelector(".btn-qty__badge").innerText = 0
      })

      bundle.utils.updateContent()
    },
    bundleQty() {
      const inCartItems = bundle.defaults.inCartItems()
      let qty = 0

      for (const item of inCartItems) {
        qty += parseInt(item.getAttribute("data-qty"))
      }

      return qty
    },

    addToCart: function ($item) {
      const new_bundle_qty = bundle.utils.bundleQty() + 1
      const new_item_qty = Number($item.getAttribute("data-qty")) + 1

      if (
        bundle.constraints.isItemLessThanMax(new_item_qty) &&
        bundle.constraints.isBundleLessThanMax(new_bundle_qty)
      ) {
        bundle.utils.updateItemQty($item, new_item_qty)
      }

      bundle.utils.updateContent()
    },
    removeProduct(productId) {
      const $item = document.querySelector(`.bundle-card[data-product-id="${productId}"]`)
      const new_item_qty = Number($item.getAttribute("data-qty")) - 1

      bundle.utils.updateItemQty($item, new_item_qty)
    },
    updateItemQty($item, new_item_qty) {
      $item.setAttribute("data-qty", new_item_qty)

      $item.classList.toggle(bundle.settings.itemInCartClass, new_item_qty > 0)

      const qtyLabel = $item.querySelector(".btn-qty__badge")
      qtyLabel.innerText = new_item_qty
    },
    updateCards() {
      const items = bundle.defaults.items()
      const maxQuantityReached = bundle.constraints.maxQuantityReached()

      for (const item of items) {
        const button = item.querySelector("button.add-to-cart")
        if (!button) continue
        button.disabled = maxQuantityReached
      }
    },

    renderEmptyHtml() {
      return `
      <div class="bundle-summary__item">
        <div class="bundle-summary__item-content">
          <div class="image is-square"></div>
        </div>
      </div>
      `
    },
    renderItemHtml($item, index) {
      const data = {
        id: $item.dataset.productId,
        image: {
          src: $item.dataset.productImageUrl,
          alt: $item.dataset.productImageAlt,
        },
      }

      return `
      <div class="bundle-summary__item active" data-product-id="${data.id}">
        <div class="bundle-summary__item-content">
         <ec-button-item-remove type="button" class="bundle-summary__item-remove" data-product-id="${data.id}">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-x-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="m15 9-6 6" />
              <path d="m9 9 6 6" />
            </svg>
          </ec-button-item-remove>
          <div class="image is-square">
            <img src="${data.image.src}" alt="${data.image.alt}" />
          </div>
        </div>
      </div>
      `
    },

    updateAddedProducts() {
      const maxItems = bundle.settings.bundleMax
      const items = bundle.defaults.inCartItems()
      const lists = document.querySelectorAll('[data-bundle-item-list="true"]')
      const bundle_qty = bundle.utils.bundleQty()
      const remaining = maxItems - bundle_qty

      const renderedItems = Array.from(items).map((item) => {
        const quantity = parseInt(item.getAttribute("data-qty"), 10)

        return Array.from({ length: quantity }, () => this.renderItemHtml(item)).join("")
      })

      if (remaining > 0) {
        const remainderItem = Array.from({ length: remaining }, () => this.renderEmptyHtml())
        renderedItems.push(...remainderItem)
      }

      lists.forEach((list) => {
        list.innerHTML = renderedItems.join("")
      })
    },

    updateAddToCartButton() {
      const qty = this.bundleQty()
      const max = bundle.settings.bundleMax
      const min = bundle.settings.bundleMin

      const $buttons = document.querySelectorAll(".cb-add-to-cart-btn")
      const $startBuildingBtn = document.getElementById("ec-start-building-button")

      // const $stickyGetStarted = document.querySelector(".sticky-get-started")
      // $stickyGetStarted.classList.toggle("bundle-active", qty > 0)

      console.log("this is running")
      console.log(qty)

      if (qty > 1) {
        $startBuildingBtn.style.display = "none"
      } else {
        $startBuildingBtn.style.display = "inline-block"
      }

      $buttons.forEach(($button) => {
        const $text = $button.querySelector(".btn-text")

        if (qty === 0) {
          $button.disabled = true
          $text.innerText = `Start Building`

          $button.style.display = "none"
          $startBuildingBtn.style.display = "inline-block"
        } else {
          // $stickyGetStarted.classList.add("bundle-active")
          // $stickyGetStarted.classList.add("hidden")

          $button.style.display = "inline-block"
          $startBuildingBtn.style.display = "none"

          if (qty < max) {
            $button.disabled = true
            $text.innerText = `select ${max - qty} more products`
          } else if (qty > max) {
            $button.disabled = true
            $text.innerText = `remove ${qty - max} item${qty - max > 1 ? "s" : ""}`
          } else {
            $button.disabled = false
            $text.innerText = `Checkout`
          }
        }
      })
    },

    updatePrices() {
      const $price = document.querySelector(".ec-price")
      const $comparePrice = document.querySelector(".ec-compare")

      $price.innerText = formatCurrency(bundle.selectedProduct.price)
      $comparePrice.innerText = formatCurrency(bundle.selectedProduct.comparePrice)
    },

    updateContent() {
      bundle.utils.updateCards()
      bundle.utils.updateAddedProducts()
      bundle.utils.updateAddToCartButton()
      bundle.utils.updatePrices()
    },

    updateQuantitySelect(event) {
      const select = event.target
      const newValue = select.value

      quantitySelect.forEach((select) => {
        select.value = newValue
      })

      const frequencyContainer = document.querySelectorAll(".bundle-frequency")
      frequencyContainer.forEach((elm) => {
        const elmIndex = elm.getAttribute("data-bundle-index")

        if (elmIndex === newValue) {
          elm.classList.add("frequency-active")
        } else {
          elm.classList.remove("frequency-active")
        }
      })

      const parsedData = bundle.defaults.getProductData()
      const currentProduct = parsedData[newValue - 1]

      if (currentProduct) {
        bundle.selectedProduct = currentProduct
        bundle.product = currentProduct
        bundle.settings = {
          ...bundle.settings,
          bundleMin: currentProduct.bundleMin,
          bundleMax: currentProduct.bundleMax,
        }

        this.updateContent()
      }
    },

    updateCurrentFrequency(e) {
      const select = e.target
      const newValue = select.value

      frequencySelect.forEach((select) => {
        select.value = newValue
      })
    },
  },

  modal: {
    open(id) {
      if (!id) {
        console.log("No product ID")
        return
      }

      bundle.defaults.getModal().open()
      this.modalLoadingState(true)

      const urlParams = new URLSearchParams(window.location.search)
      const variantParam = urlParams.get("variant")

      let fetchURL = `/products/${id}?section_id=essentials-club-product-modal`

      fetch(fetchURL)
        .then((res) => res.text())
        .then((state) => {
          const parser = new DOMParser()
          const html = parser.parseFromString(state, "text/html")

          const source = html.querySelector("#step-bundle-modal-product")
          const destination = document.querySelector("#step-bundle-modal-product")

          if (source && destination) destination.innerHTML = source.innerHTML
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.modalLoadingState(false)
          this.validateModalElements()
        })
    },
    modalLoadingState(loading = false) {
      const modal = bundle.defaults.getModal()
      if (loading) {
        modal.classList.add("isLoading")
      } else {
        modal.classList.remove("isLoading")
      }
    },
    addingToCart($item) {
      const mainItem = document.querySelector(
        `.bundle-card[data-product-id="${$item.getAttribute("data-product-id")}"]`,
      )

      const new_bundle_qty = bundle.utils.bundleQty() + 1
      const new_item_qty = Number(mainItem.getAttribute("data-qty")) + 1

      if (
        bundle.constraints.isItemLessThanMax(new_item_qty) &&
        bundle.constraints.isBundleLessThanMax(new_bundle_qty)
      ) {
        bundle.utils.updateItemQty(mainItem, new_item_qty)
      }

      bundle.utils.updateContent()
      this.validateModalElements()
    },
    validateModalElements() {
      const modal = bundle.defaults.getModal()
      const button = modal.querySelector(".add-to-cart")
      const text = modal.querySelector(".btn-qty__badge")

      const qty = parseInt(
        document
          .querySelector(`.bundle-card[data-product-id="${button.getAttribute("data-variant-id")}"]`)
          .getAttribute("data-qty"),
      )

      if (qty > 0) {
        text.style.display = "block"
      } else {
        text.style.display = "none"
      }

      text.innerText = qty

      button.disabled = bundle.constraints.maxQuantityReached()
    },
  },

  constraints: {
    isItemEqualToStock: function (stock, qty) {
      return qty >= stock
    },
    isItemEqualToMax: function (qty) {
      return qty >= bundle.settings.limitPerItem
    },
    isItemLessThanMax(new_qty) {
      if (new_qty > bundle.settings.limitPerItem) {
        alert(`You can only add ${bundle.settings.limitPerItem} of this item to your bundle.`)
        return false
      }
      return true
    },
    isBundleLessThanMax(new_qty) {
      if (new_qty > bundle.settings.bundleMax) {
        alert(`You can only add ${bundle.settings.bundleMax} items to your bundle.`)
        return false
      }
      return true
    },
    maxQuantityReached() {
      const bundle_qty = bundle.utils.bundleQty()
      const limit = bundle.settings.bundleMax

      return bundle_qty >= limit
    },
  },

  cart: {
    processCart(btn) {
      const bundleId = getGuid()

      const items = bundle.cart.generateCartItems(bundleId)

      const hasDiscount = btn.getAttribute("data-has-discount") || null
      const hadAdditionalItem = btn.getAttribute("data-has-auto-product") || null

      if (items.length > 0) {
        bundle.cart.processToCart(items, hasDiscount, hadAdditionalItem)
      } else {
        console.log("NO ITEMS AVAILABLE")
      }
    },
    getParentItem(bundleId) {
      const sellingWrapper = document.querySelector(".bundle-frequency.frequency-active")
      console.log(sellingWrapper)
      const sellingPlan = sellingWrapper ? sellingWrapper.querySelector("select").value : null

      return {
        id: bundle.product.variantId,
        quantity: 1,
        selling_plan: sellingPlan,
        properties: {
          _bundle_id: bundleId,
          _bundle_parent: true,
        },
      }
    },
    generateCartItems(bundleId) {
      let cart = []

      const parentItem = this.getParentItem(bundleId)
      cart.push(parentItem)

      const selling_plan = parentItem.selling_plan

      bundle.defaults.inCartItems().forEach((item) => {
        const quantity = parseInt(item.getAttribute("data-qty"), 10)

        if (quantity > 0) {
          const cartItem = {
            id: item.getAttribute("data-product-id"),
            quantity: quantity,
            selling_plan,
            properties: {
              _bundle_id: bundleId,
            },
          }

          cart.push(cartItem)
        }
      })

      //Sort cart item list
      cart.sort((a, b) => {
        if (a.properties._bundle_parent && !b.properties._bundle_parent) {
          return 1 // b comes first
        } else if (!a.properties._bundle_parent && b.properties._bundle_parent) {
          return -1 // a comes first
        } else {
          return 0 // preserve the order
        }
      })

      return cart
    },
    processToCart(items, discount, hadAdditionalItem) {
      const finalItems = hadAdditionalItem ? [...items, { id: hadAdditionalItem, quantity: 1 }] : [...items]

      const data = {
        items: finalItems,
      }

      console.log("BUNDLE DATA: ", data)

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => {
          if (!res.ok) {
            let errorMessage = `Failed to add items to cart.`
            throw new Error(errorMessage)
          }

          return res.json()
        })
        .then((data) => {
          console.log("Success:", data)

          if (discount) {
            window.location.href = `/checkout?discount=${discount}`
            // https://beautybyearth.com/discount/myfirstbox?redirect=checkout
            // https://beautybyearth.com/discount/myfirstbox?redirect=%2Fproducts%2Ffree-full-sized-gift-essentials-club-1st-box
            //window.location.href = `https://beautybyearth.com/discount/${discount}?redirect=%2Fcheckout`
          } else {
            window.location.href = "/checkout"
          }
        })
        .catch((error) => {
          console.error("Error:", error)
          const toastNode = document.createElement("div")
          toastNode.innerHTML = `
            <div class='tw:space-y-2 tw:max-w-xs'>
              <h2 class='tw:text-base tw:font-semibold tw:font-sans tw:flex tw:items-center tw:gap-2'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='lucide lucide-info-icon lucide-info tw:text-error'><circle cx='12' cy='12' r='10'/><path d='M12 16v-4'/><path d='M12 8h.01'/></svg>
              Oops! Something went wrong.
              </h2>
              <p class='tw:text-sm tw:text-gray-700'>
                We couldn't complete your Essentials Club bundle right now. Please try again or reach out to our support team if the problem continues.
              </p>
              <button class='button button-sm' data-toast-close>Got it</button>
            </div>
          `

          Toastify({ node: toastNode, duration: -1 }).showToast()
        })
    },
  },

  init() {
    const addToCart = document.querySelectorAll(bundle.settings.itemIncreaseButtonSelector)
    addToCart.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault()
        const $item = button.closest(bundle.settings.itemSelector)
        bundle.utils.addToCart($item)
      })
    })

    // Add an event listener for the remove buttons
    document.addEventListener("click", function (event) {
      if (event.target.classList.contains("add-to-cart-modal")) {
        const btn = event.target

        const item = btn.closest("[data-ec-bundle-item]")

        bundle.modal.addingToCart(item)
      }
    })

    quantitySelect.forEach((select) => {
      select.addEventListener("change", (e) => {
        bundle.utils.updateQuantitySelect(e)
      })
    })

    frequencySelect.forEach((select) => {
      select.addEventListener("change", (e) => {
        bundle.utils.updateCurrentFrequency(e)
      })
    })

    document.querySelectorAll(".bundle-card__image").forEach((elm) => {
      elm.addEventListener("click", (e) => {
        bundle.modal.open(elm.getAttribute("data-product-id"))
      })
    })

    const addToCartBtn = document.querySelector(".cb-add-to-cart-btn")
    addToCartBtn.addEventListener("click", (e) => {
      addToCartBtn.classList.add("loading")
      bundle.cart.processCart(addToCartBtn)
    })

    const parsedData = bundle.defaults.getProductData()
    bundle.selectedProduct = parsedData[0]
    bundle.product = parsedData[0]
    bundle.settings = {
      ...bundle.settings,
      bundleMin: parsedData[0].bundleMin,
      bundleMax: parsedData[0].bundleMax,
    }
  },
}

bundle.init()
bundle.utils.updateContent()

class ClearCartButton extends HTMLElement {
  constructor() {
    super()

    this.addEventListener("click", this.handleClick.bind(this))
  }

  handleClick() {
    fetch(`/cart/clear.js`)
      .then((res) => res.json())
      .then((res) => console.log(res))

    bundle.utils.clearCart()
  }
}

customElements.define("clear-cart-button", ClearCartButton)

class EcButtonRemoveItem extends HTMLElement {
  constructor() {
    super()

    this.addEventListener("click", this.handleClick.bind(this))
  }

  handleClick() {
    const productId = this.getAttribute("data-product-id")
    bundle.utils.removeProduct(productId)
    bundle.utils.updateContent()
  }
}

customElements.define("ec-button-item-remove", EcButtonRemoveItem)

// Function to handle the intersection changes
window.addEventListener("scroll", () => {
  const nav = document.getElementById("your-nav-id")
  const bundleSec = document.querySelector(".bundle-summary")
  const footer = document.querySelector(".ec-add-to-cart-container")

  if (bundleSec && window.scrollY > bundleSec.offsetTop + 400) {
    nav.classList.add("is-visible")
  } else {
    nav.classList.remove("is-visible")
  }

  if (bundleSec && window.scrollY > bundleSec.offsetTop - 300) {
    footer.classList.remove("hidden")
  } else {
    footer.classList.add("hidden")
  }
})

const handleIntersection = (entries, observer) => {
  entries.forEach((entry) => {
    const nav = document.querySelector(".sticky-get-started")

    if (!nav) return

    if (entry.isIntersecting) {
      nav.classList.add("hidden")
    } else {
      nav.classList.remove("hidden")
    }
  })
}

// Create a new Intersection Observer
const observer = new IntersectionObserver(handleIntersection, {
  root: null, // Viewport
  threshold: 0, // Trigger when the target is partially in view
})

// Observe the target element
const target = document.getElementById("bundle-sec")
if (target) {
  observer.observe(target)
}
